
import { defineComponent, ref } from 'vue';
import InputSelect from '@/components/input/InputSelect.vue';
import { useStore } from 'vuex';
import { POST_TRANSACTION, PUT_TRANSACTION } from "@/store/transaction.module";

export default defineComponent({
  components: {
    InputSelect,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    id:{
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}) // Provide a default object to prevent undefined errors
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const modalContent = ref(null);
    const isLoading = ref(false);

    const closeModal = () => {
      isLoading.value = false;
      emit('close');
    };

    const formData = {
      id: '',
      data: {} as Record<string, any>
    }

    const updateValue = (params: { key: string; value: any }) => {
      formData.data[params.key] = params.value;
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {
        if(props?.id){
          formData.id = props?.id
          await store.dispatch(PUT_TRANSACTION, formData);
        }else{
          await store.dispatch(POST_TRANSACTION, formData);
        }
        closeModal();
      } catch (error) {
        console.error('Failed to create merchandise:', error);
        alert(error);
        isLoading.value = false;
      }
    };

    return {
      modalContent,
      closeModal,
      handleSubmit,
      updateValue,
      isLoading
    };
  },
});
